import { AddArtifactRequestSchema, AddArtifactResponseSchema } from './add-artifact.schema';
/**
 * Add Artifact Endpoint Contract
 * Creates a new artifact in the organization
 */ export const addArtifactContract = {
    method: 'POST',
    path: '/api/v2/artifact',
    description: 'Create a new artifact in the organization',
    requestSchema: AddArtifactRequestSchema,
    responseSchema: AddArtifactResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=add-artifact.contract.js.map